import React from 'react';
import spinnerImage from '../Assets/Images/remesalogo.png';

function Spinner() {
  return (
    <div className="remesa-spinner">
      <div className="remesa-spinner__content">
        <img
          src={spinnerImage}
          alt="Cargando Remesa España"
          className="remesa-spinner__image"
        />
        <div className="remesa-spinner__loader"></div>
      </div>
    </div>
  );
}

export { Spinner };
